import { storeCtaOpts } from 'components/store-status/constants';

import { useTLang } from 'intl/intl';

import type { StoreStatus } from 'business/highDemand';
import type { TpStoreCtaOpts } from 'components/store-status/types';

export function useEmptyStoreStatusTexts(props: Props) {
  const { status, cta } = props;

  const title = `highDemand.state.${status}.title`;
  const subTitle = `highDemand.state.${status}.subTitle`;

  return {
    title: useTLang({ id: title }),
    subTitle: useTLang({ id: subTitle }),
    cta: useTLang({ id: storeCtaOpts[cta].textId }),
  };
}

interface Props {
  status: StoreStatus;
  cta: TpStoreCtaOpts;
}
